"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const LogManager_1 = require("../Log/LogManager");
const TypeScriptUtils_1 = require("../Common/TypeScriptUtils");
const Entity_1 = require("../Common/Entity");
const IEventHub_1 = require("../Engine/Event/IEventHub");
const UserDefinition_1 = require("./UserDefinition");
const UserCommand_1 = require("./UserCommand");
const UserEvent_1 = require("./UserEvent");
const Contact_1 = require("./Contact");
const NullUserRepository_1 = require("./Port/NullUserRepository");
const NullCommandHub_1 = require("../Engine/Command/Port/NullCommandHub");
const NullEventHub_1 = require("../Engine/Event/Port/NullEventHub");
const CommonBaseError_1 = require("../Common/CommonBaseError");
const UserDto_1 = require("./Protocol/UserDto");
const RtcCommand_1 = require("../Engine/Command/RtcCommand");
const UserUtils_1 = require("./Protocol/UserUtils");
class User extends Entity_1.Entity {
    constructor(userObj) {
        super(userObj._isService, User.logger, UserDefinition_1.UserCommandCategory, userObj._commandHub, UserDefinition_1.UserEventCategory, userObj._eventHub);
        this._id = "";
        this._version = User.CurrentVersion;
        this._username = "";
        this._displayName = "";
        this._isOnline = false;
        this._avatar = "";
        this._contacts = [];
        this._id = userObj._id;
        this._version = userObj._version;
        this._username = userObj._username;
        this._displayName = userObj._displayName;
        this._isOnline = userObj._isOnline;
        this._avatar = userObj._avatar;
        this._contacts = userObj._contacts.slice();
        this._userRepo = userObj._userRepo;
        this.registerAsyncCommandHandler(UserCommand_1.UserCommand.FetchContactStatus, async (rtcCmd) => this.OnFetchContactStatusCommand(rtcCmd));
        this.registerAsyncCommandHandler(UserCommand_1.UserCommand.AddContact, async (rtcCmd) => this.OnAddContactCommand(rtcCmd));
        this.registerAsyncCommandHandler(UserCommand_1.UserCommand.HideContact, async (rtcCmd) => this.OnHideContactCommand(rtcCmd));
        this.registerAsyncCommandHandler(UserCommand_1.UserCommand.BlockContact, async (rtcCmd) => this.OnBlockContactCommand(rtcCmd));
        this.registerAsyncCommandHandler(UserCommand_1.UserCommand.RecoverContact, async (rtcCmd) => this.OnRecoverContactCommand(rtcCmd));
        this.registerAsyncCommandHandler(UserCommand_1.UserCommand.RemoveContact, async (rtcCmd) => this.OnRemoveContactCommand(rtcCmd));
        this.registerAsyncCommandHandler(UserCommand_1.UserCommand.AddContactToFavorite, async (rtcCmd) => this.OnAddContactToFavoriteCommand(rtcCmd));
        this.registerAsyncCommandHandler(UserCommand_1.UserCommand.RemoveContactFromFavorite, async (rtcCmd) => this.OnRemoveContactToFavoriteCommand(rtcCmd));
        this.registerAsyncEventHandler(UserEvent_1.UserEvent.UserIsOnline, async (evt) => this.OnUserIsOnlineEvent(evt));
        this.registerAsyncEventHandler(UserEvent_1.UserEvent.UserIsOffline, async (evt) => this.OnUserIsOfflineEvent(evt));
        this.registerAsyncEventHandler(UserEvent_1.UserEvent.ContactIsAdded, async (evt) => this.OnAddContactEvent(evt));
        this.registerAsyncEventHandler(UserEvent_1.UserEvent.ContactIsHidden, async (evt) => this.OnHideContactEvent(evt));
        this.registerAsyncEventHandler(UserEvent_1.UserEvent.ContactIsBlocked, async (evt) => this.OnBlockContactEvent(evt));
        this.registerAsyncEventHandler(UserEvent_1.UserEvent.ContactIsRecoverd, async (evt) => this.OnRecoverContactEvent(evt));
        this.registerAsyncEventHandler(UserEvent_1.UserEvent.ContactIsRemoved, async (evt) => this.OnRemoveContactEvent(evt));
        this.registerAsyncEventHandler(UserEvent_1.UserEvent.ContactBecameFavorite, async (evt) => this.OnAddContactToFavoriteEvent(evt));
        this.registerAsyncEventHandler(UserEvent_1.UserEvent.ContactBecameNotFavorite, async (evt) => this.OnRemoveContactFromFavoriteEvent(evt));
    }
    //public set id(value: string) { this._id = value }
    get id() { return this._id; }
    //public set version(value: number) { this._version = value; }
    get version() { return this._version; }
    //public set username(value: string) { this._username = value; }
    get username() { return this._username; }
    set displayName(value) { this._displayName = value; }
    get displayName() { return this._displayName; }
    set isOnline(value) { this._isOnline = value; }
    get isOnline() { return this._isOnline; }
    set avatar(value) { this._avatar = value; }
    get avatar() { return this._avatar; }
    //public set contacts(value: Contact[]) { this._contacts = value.slice(); }
    get contacts() { return this._contacts.slice(); }
    toString() {
        return JSON.stringify(this.toUserDto());
    }
    async SaveAsync(user) {
        await this._userRepo.saveAsync(user);
    }
    async OnlineAsync() {
        await this.InternalOnlineAysnc();
    }
    async InternalOnlineAysnc() {
        this.isOnline = true;
        this.addChangeRecord(new Entity_1.ChangeRecord(User.ISONLINE_PROPERTY_NAME, Entity_1.ChangeOperation.Update, this.isOnline));
        await this.SaveAsync(this);
    }
    async OnUserIsOnlineEvent(evt) {
        if (this._isService)
            throw new UserError("Not Implemented.");
        else {
            // Client端收到上線Event更新自己本地資料然後往應用層通知
            await this.InternalOnlineAysnc();
            const onlineEvt = UserEvent_1.UserEvent.UserIsOnlineEvent(this.toUserDto());
            await this.publishEventAsync(onlineEvt, [IEventHub_1.EventReceiver.CLIENT]);
        }
    }
    async OfflineAsync() {
        await this.InternalOfflineAysnc();
    }
    async InternalOfflineAysnc() {
        this.isOnline = false;
        this.addChangeRecord(new Entity_1.ChangeRecord(User.ISONLINE_PROPERTY_NAME, Entity_1.ChangeOperation.Update, this.isOnline));
        await this.SaveAsync(this);
    }
    async OnUserIsOfflineEvent(e) {
        if (this._isService)
            throw new UserError("Not Implemented.");
        else {
            await this.InternalOfflineAysnc();
            const offlineEvt = UserEvent_1.UserEvent.UserIsOfflineEvent(this.toUserDto());
            await this.publishEventAsync(offlineEvt, [IEventHub_1.EventReceiver.CLIENT]);
        }
    }
    async AddContactAsync(contact) {
        const result = await this.InternalAddContactAsync(contact);
        const addedContact = result.Item1;
        const existContact = result.Item2;
        if (addedContact === Contact_1.Contact.Nobody)
            return;
        if (this._isService)
            throw new UserError("Not Implemented.");
        else {
            await this.sendCommandAsync(UserCommand_1.UserCommand.AddContactCommand(this.id, addedContact));
        }
    }
    async InternalAddContactAsync(contact) {
        if (!contact.id)
            throw new UserError(`contact.id cannot be empty.`);
        if (!contact.name)
            throw new UserError(`contact.name cannot be empty.`);
        if (contact.id === this.id)
            throw new UserError(`can not add contact with self ID=${contact.id} as contact.`);
        if (contact.name === this.username)
            throw new UserError(`can not add contact with self Username=${contact.name} as contact.`);
        if (this.HasAddedContact(contact.id)) {
            this._logger.debug("Try to add duplicated contact, something wrong?");
            return TypeScriptUtils_1.NewTuple2(Contact_1.Contact.Nobody, Contact_1.Contact.Nobody);
        }
        //處理已經存在但是狀態是隱藏或是刪除的Contact
        const existContact = this.ContactOfId(contact.id);
        const addedContact = new Contact_1.Contact(contact, Contact_1.ContactStatus.Added);
        if (existContact === Contact_1.Contact.Nobody) {
            //Contact doesn't exist before
            this._contacts.push(addedContact);
            this.addChangeRecord(new Entity_1.ChangeRecord(User.CONTACTS_PROPERTY_NAME, Entity_1.ChangeOperation.Add, addedContact));
        }
        else {
            //Contact exists but Contact's status is not added.
            const existIdx = this._contacts.indexOf(existContact);
            this._contacts.splice(existIdx, 1);
            this._contacts.push(addedContact);
            this.addChangeRecord(new Entity_1.ChangeRecord(User.CONTACTS_PROPERTY_NAME, Entity_1.ChangeOperation.Update, addedContact));
        }
        await this.SaveAsync(this);
        return TypeScriptUtils_1.NewTuple2(addedContact, existContact);
    }
    async OnAddContactCommand(rtcCmd) {
        if (this._isService)
            throw new UserError("Not Implemented.");
        else {
            switch (rtcCmd.type) {
                case RtcCommand_1.CmdType.ResponseFail:
                    {
                        this._logger.debug("加Contact失敗, 把原來已經加的Contact刪除");
                        const contact = new Contact_1.Contact(rtcCmd.contentTo());
                        const addedContact = this.ContactOfId(contact.id);
                        if (addedContact === Contact_1.Contact.Nobody)
                            return;
                        const existIdx = this._contacts.indexOf(addedContact);
                        this._contacts.splice(existIdx, 1);
                        this.addChangeRecord(new Entity_1.ChangeRecord(User.CONTACTS_PROPERTY_NAME, Entity_1.ChangeOperation.Remove, addedContact));
                        await this.SaveAsync(this);
                    }
                    break;
            }
        }
    }
    async OnAddContactEvent(e) {
        if (this._isService)
            throw new UserError("Not Implemented.");
        else {
            const body = e.bodyTo();
            const addedContact = new Contact_1.Contact(body.Item1);
            const addedContactUserDto = UserDto_1.newUserDto(body.Item2);
            // 把新加進來的User存下來
            const contactUser = User.Builder(this._userRepo, this._commandHub, this._eventHub)
                .id(addedContactUserDto.id)
                .username(addedContactUserDto.username)
                .displayName(addedContactUserDto.displayname)
                .contacts(addedContactUserDto.contacts)
                .avatar(addedContactUserDto.avatar)
                .isOnline(addedContactUserDto.isOnline)
                .build();
            await this.SaveAsync(contactUser);
            const evt = UserEvent_1.UserEvent.ContactIsAddedEvent(this.toUserDto(), addedContact, addedContactUserDto);
            await this.publishEventAsync(evt, [IEventHub_1.EventReceiver.CLIENT]);
        }
    }
    async HideContactAsync(contact) {
        const result = await this.InternalHideContactAsync(contact);
        const hideContact = result.Item1;
        const beforeHideContact = result.Item2;
        if (hideContact === Contact_1.Contact.Nobody)
            return;
        if (this._isService)
            throw new UserError("Not Implemented.");
        else {
            await this.sendCommandAsync(UserCommand_1.UserCommand.HideContactCommand(this.id, beforeHideContact));
        }
    }
    async InternalHideContactAsync(contact) {
        if (!contact.id)
            throw new UserError(`contact.id cannot be empty.`);
        if (!contact.name)
            throw new UserError(`contact.name cannot be empty.`);
        const beforeHideContact = this.ContactOfId(contact.id);
        if (beforeHideContact === Contact_1.Contact.Nobody || beforeHideContact.status === Contact_1.ContactStatus.Hide) {
            this._logger.debug(`${contact} is not in ${this.username}'s contact, nothing to do.`);
            return TypeScriptUtils_1.NewTuple2(Contact_1.Contact.Nobody, Contact_1.Contact.Nobody);
        }
        if (beforeHideContact.status !== Contact_1.ContactStatus.Added &&
            beforeHideContact.status !== Contact_1.ContactStatus.Blocked)
            throw new UserError(`${contact} is not valid contact to hide.`);
        const existIdx = this._contacts.indexOf(beforeHideContact);
        this._contacts.splice(existIdx, 1);
        const hideContact = new Contact_1.Contact(beforeHideContact, Contact_1.ContactStatus.Hide);
        this._contacts.push(hideContact);
        this.addChangeRecord(new Entity_1.ChangeRecord(User.CONTACTS_PROPERTY_NAME, Entity_1.ChangeOperation.Update, hideContact));
        await this.SaveAsync(this);
        return TypeScriptUtils_1.NewTuple2(hideContact, beforeHideContact);
    }
    async OnHideContactCommand(rtcCmd) {
        if (this._isService)
            throw new UserError("Not Implemented.");
        else {
            switch (rtcCmd.type) {
                case RtcCommand_1.CmdType.ResponseFail:
                    {
                        this._logger.debug("隱藏Contact失敗, 把原來已經隱藏的Contact回復");
                        const contact = new Contact_1.Contact(rtcCmd.contentTo());
                        await this.RollbackContactToPreviousStatusAsync(contact);
                    }
                    break;
            }
        }
    }
    async OnHideContactEvent(e) {
        if (this._isService)
            throw new UserError("Not Implemented.");
        else {
            const body = e.bodyTo();
            const hideContact = new Contact_1.Contact(body.Item1);
            let hideContactUserDto = UserDto_1.newUserDto(body.Item2);
            await this.InternalHideContactAsync(hideContact);
            if (!hideContactUserDto.isValid()) {
                const hideContactUser = await this._userRepo.userOfIdAsync(hideContact.id);
                hideContactUserDto = hideContactUser.toUserDto();
            }
            const evt = UserEvent_1.UserEvent.ContactIsHiddenEvent(this.toUserDto(), hideContact, hideContactUserDto);
            await this.publishEventAsync(evt, [IEventHub_1.EventReceiver.CLIENT]);
        }
    }
    async BlockContactAsync(contact) {
        const result = await this.InternalBlockContactAsync(contact);
        const blockedContact = result.Item1;
        const beforeBlockContact = result.Item2;
        if (blockedContact === Contact_1.Contact.Nobody)
            return;
        if (this._isService)
            throw new UserError("Not Implemented.");
        else {
            await this.sendCommandAsync(UserCommand_1.UserCommand.BlockContactCommand(this.id, beforeBlockContact));
        }
    }
    async InternalBlockContactAsync(contact) {
        if (!contact.id)
            throw new UserError(`contact.id cannot be empty.`);
        if (!contact.name)
            throw new UserError(`contact.name cannot be empty.`);
        const beforeBlockContact = this.ContactOfId(contact.id);
        if (beforeBlockContact === Contact_1.Contact.Nobody || beforeBlockContact.status === Contact_1.ContactStatus.Blocked) {
            this._logger.debug(`${contact} is not in ${this.username}'s contact, nothing to do.`);
            return TypeScriptUtils_1.NewTuple2(Contact_1.Contact.Nobody, Contact_1.Contact.Nobody);
        }
        if (beforeBlockContact.status !== Contact_1.ContactStatus.Added &&
            beforeBlockContact.status !== Contact_1.ContactStatus.Hide) {
            throw new UserError(`${contact} is not valid contact to block.`);
        }
        const existIdx = this._contacts.indexOf(beforeBlockContact);
        this._contacts.splice(existIdx, 1);
        const blockedContact = new Contact_1.Contact(beforeBlockContact, Contact_1.ContactStatus.Blocked);
        this._contacts.push(blockedContact);
        this.addChangeRecord(new Entity_1.ChangeRecord(User.CONTACTS_PROPERTY_NAME, Entity_1.ChangeOperation.Update, blockedContact));
        await this.SaveAsync(this);
        return TypeScriptUtils_1.NewTuple2(blockedContact, beforeBlockContact);
    }
    async OnBlockContactCommand(rtcCmd) {
        if (this._isService)
            throw new UserError("Not Implemented.");
        else {
            switch (rtcCmd.type) {
                case RtcCommand_1.CmdType.ResponseFail:
                    {
                        this._logger.debug("封鎖Contact失敗, 把原來已經封鎖的Contact回復");
                        const contact = new Contact_1.Contact(rtcCmd.contentTo());
                        await this.RollbackContactToPreviousStatusAsync(contact);
                    }
                    break;
            }
        }
    }
    async OnBlockContactEvent(e) {
        if (this._isService)
            throw new UserError("Not Implemented.");
        else {
            const body = e.bodyTo();
            const blockedContact = new Contact_1.Contact(body.Item1);
            let blockedContactUserDto = UserDto_1.newUserDto(body.Item2);
            await this.InternalBlockContactAsync(blockedContact);
            if (!blockedContactUserDto.isValid()) {
                const blockedContactUser = await this._userRepo.userOfIdAsync(blockedContact.id);
                blockedContactUserDto = blockedContactUser.toUserDto();
            }
            const evt = UserEvent_1.UserEvent.ContactIsBlockedEvent(this.toUserDto(), blockedContact, blockedContactUserDto);
            await this.publishEventAsync(evt, [IEventHub_1.EventReceiver.CLIENT]);
        }
    }
    async RecoverContactAsync(contact) {
        const result = await this.InternalRecoverContactAsync(contact);
        const recoveredContact = result.Item1;
        const beforeRecoverContact = result.Item2;
        if (recoveredContact === Contact_1.Contact.Nobody)
            return;
        if (this._isService)
            throw new UserError("Not Implemented.");
        else {
            await this.sendCommandAsync(UserCommand_1.UserCommand.RecoverContactCommand(this.id, beforeRecoverContact));
        }
    }
    async InternalRecoverContactAsync(contact) {
        if (!contact.id)
            throw new UserError(`contact.id cannot be empty.`);
        if (!contact.name)
            throw new UserError(`contact.name cannot be empty.`);
        const beforeRecoverContact = this.ContactOfId(contact.id);
        if (beforeRecoverContact === Contact_1.Contact.Nobody
            || beforeRecoverContact.status === Contact_1.ContactStatus.Added
            || beforeRecoverContact.status === Contact_1.ContactStatus.None
            || beforeRecoverContact.status === Contact_1.ContactStatus.BlockedRemoved
            || beforeRecoverContact.status === Contact_1.ContactStatus.HideRemoved) {
            this._logger.debug(`${contact} doesn't need recovery`);
            return TypeScriptUtils_1.NewTuple2(Contact_1.Contact.Nobody, Contact_1.Contact.Nobody);
        }
        const existIdx = this._contacts.indexOf(beforeRecoverContact);
        this._contacts.splice(existIdx, 1);
        const recoveredContact = new Contact_1.Contact(beforeRecoverContact, Contact_1.ContactStatus.Added);
        this._contacts.push(recoveredContact);
        this.addChangeRecord(new Entity_1.ChangeRecord(User.CONTACTS_PROPERTY_NAME, Entity_1.ChangeOperation.Update, recoveredContact));
        await this.SaveAsync(this);
        return TypeScriptUtils_1.NewTuple2(recoveredContact, beforeRecoverContact);
    }
    async OnRecoverContactCommand(rtcCmd) {
        if (this._isService)
            throw new UserError("Not Implemented.");
        else {
            switch (rtcCmd.type) {
                case RtcCommand_1.CmdType.ResponseFail:
                    {
                        this._logger.debug("回復Contact失敗, 把原來已經回復的Contact回到之前封鎖/隱藏的狀態");
                        const contact = new Contact_1.Contact(rtcCmd.contentTo());
                        await this.RollbackContactToPreviousStatusAsync(contact);
                    }
                    break;
            }
        }
    }
    async OnRecoverContactEvent(e) {
        if (this._isService)
            throw new UserError("Not Implemented.");
        else {
            const body = e.bodyTo();
            const recoveredContact = new Contact_1.Contact(body.Item1);
            let recoveredContactUserDto = UserDto_1.newUserDto(body.Item2);
            await this.InternalRecoverContactAsync(recoveredContact);
            if (!recoveredContactUserDto.isValid()) {
                const recoveredContactUser = await this._userRepo.userOfIdAsync(recoveredContact.id);
                recoveredContactUserDto = recoveredContactUser.toUserDto();
            }
            const evt = UserEvent_1.UserEvent.ContactIsRecoverdEvent(this.toUserDto(), recoveredContact, recoveredContactUserDto);
            await this.publishEventAsync(evt, [IEventHub_1.EventReceiver.CLIENT]);
        }
    }
    async RemoveContactAsync(contact) {
        const result = await this.InternalRemoveContactAsync(contact);
        const removedContact = result.Item1;
        const beforeRemoveContact = result.Item2;
        if (removedContact === Contact_1.Contact.Nobody)
            return;
        if (this._isService)
            throw new UserError("Not Implemented.");
        else {
            await this.sendCommandAsync(UserCommand_1.UserCommand.RemoveContactCommand(this.id, beforeRemoveContact));
        }
    }
    async InternalRemoveContactAsync(contact) {
        if (!contact.id)
            throw new UserError(`contact.id cannot be empty.`);
        if (!contact.name)
            throw new UserError(`contact.name cannot be empty.`);
        const beforeRemoveContact = this.ContactOfId(contact.id);
        if (beforeRemoveContact === Contact_1.Contact.Nobody) {
            this._logger.debug(`${contact} is not this user's contact, do nothing.`);
            return TypeScriptUtils_1.NewTuple2(Contact_1.Contact.Nobody, Contact_1.Contact.Nobody);
        }
        switch (beforeRemoveContact.status) {
            case Contact_1.ContactStatus.Added:
            case Contact_1.ContactStatus.Blocked:
            case Contact_1.ContactStatus.Hide:
                break;
            case Contact_1.ContactStatus.BlockedRemoved:
            case Contact_1.ContactStatus.HideRemoved:
                this._logger.debug(`${contact} is in removed status, no need to remove.`);
                return TypeScriptUtils_1.NewTuple2(Contact_1.Contact.Nobody, Contact_1.Contact.Nobody);
            case Contact_1.ContactStatus.None:
                throw new UserError(`${beforeRemoveContact} is not valid contact to remove.`);
        }
        const existIdx = this._contacts.indexOf(beforeRemoveContact);
        this._contacts.splice(existIdx, 1);
        const nextStatus = (beforeRemoveContact.status !== Contact_1.ContactStatus.Blocked) ? Contact_1.ContactStatus.HideRemoved : Contact_1.ContactStatus.BlockedRemoved;
        const removedContact = new Contact_1.Contact(beforeRemoveContact, nextStatus);
        this._contacts.push(removedContact);
        this.addChangeRecord(new Entity_1.ChangeRecord(User.CONTACTS_PROPERTY_NAME, Entity_1.ChangeOperation.Update, removedContact));
        await this.SaveAsync(this);
        return TypeScriptUtils_1.NewTuple2(removedContact, beforeRemoveContact);
    }
    async OnRemoveContactCommand(rtcCmd) {
        if (this._isService)
            throw new UserError("Not Implemented.");
        else {
            switch (rtcCmd.type) {
                case RtcCommand_1.CmdType.ResponseFail:
                    {
                        // 移除Contact失敗，Rollback本地資料
                        const removingContact = new Contact_1.Contact(rtcCmd.contentTo());
                        await this.RollbackContactToPreviousStatusAsync(removingContact);
                    }
                    break;
            }
        }
    }
    async OnRemoveContactEvent(e) {
        if (this._isService)
            throw new UserError("Not Implemented.");
        else {
            const body = e.bodyTo();
            const removedContact = new Contact_1.Contact(body.Item1);
            let removedContactUserDto = UserDto_1.newUserDto(body.Item2);
            await this.InternalRemoveContactAsync(removedContact);
            if (!removedContactUserDto.isValid()) {
                const removedContactUser = await this._userRepo.userOfIdAsync(removedContact.id);
                removedContactUserDto = removedContactUser.toUserDto();
            }
            const evt = UserEvent_1.UserEvent.ContactIsRemovedEvent(this.toUserDto(), removedContact, removedContactUserDto);
            await this.publishEventAsync(evt, [IEventHub_1.EventReceiver.CLIENT]);
        }
    }
    async FetchContactStatusAsync() {
        if (this._isService)
            throw new UserError("Not Implemented.");
        else {
            await this.sendCommandAsync(UserCommand_1.UserCommand.FetchContactStatusRequestExecuteCommand(this.id));
        }
    }
    async OnFetchContactStatusCommand(rtcCmd) {
        if (this._isService)
            throw new UserError("Not Implemented.");
        else {
            if (rtcCmd.type === RtcCommand_1.CmdType.ResponseAccept) {
                const contacts = rtcCmd.contentTo();
                for (const c of contacts) {
                    const contact = new Contact_1.Contact(c);
                    const existContact = this._contacts.find(c => {
                        return (c.id === contact.id) && (c.name === contact.name);
                    });
                    if (existContact) {
                        // 把原來的移掉再加進去
                        const existIdx = this._contacts.indexOf(existContact);
                        this._contacts.splice(existIdx, 1);
                    }
                    this._contacts.push(contact);
                    await this.publishEventAsync(UserEvent_1.UserEvent.UserStatusUpdatedEvent(new UserDto_1.UserDto({
                        id: contact.id,
                        username: contact.name,
                        displayname: contact.displayName,
                        isOnline: contact.isOnline,
                        avatar: contact.avatar,
                    })), [IEventHub_1.EventReceiver.CLIENT]);
                }
                await this.SaveAsync(this);
            }
        }
    }
    async RollbackContactToPreviousStatusAsync(contact) {
        const rollbackingContact = this.ContactOfId(contact.id);
        if (rollbackingContact === Contact_1.Contact.Nobody)
            return;
        const existIdx = this._contacts.indexOf(rollbackingContact);
        this._contacts.splice(existIdx, 1);
        const rollbackContact = new Contact_1.Contact(rollbackingContact, contact.status);
        this._contacts.push(rollbackContact);
        this.addChangeRecord(new Entity_1.ChangeRecord(User.CONTACTS_PROPERTY_NAME, Entity_1.ChangeOperation.Update, rollbackContact));
        await this.SaveAsync(this);
    }
    async AddContactToFavoriteAsync(contact) {
        const result = await this.InternalAddContactToFavoriteAsync(contact);
        const favoriteContact = result.Item1;
        const beforeBecomeFavoriteContact = result.Item2;
        if (favoriteContact === Contact_1.Contact.Nobody)
            return;
        if (this._isService)
            throw new UserError("Not Implemented.");
        else {
            await this.sendCommandAsync(UserCommand_1.UserCommand.AddContactToFavoriteCommand(this.id, beforeBecomeFavoriteContact));
        }
    }
    async InternalAddContactToFavoriteAsync(contact) {
        if (!contact.id)
            throw new UserError(`contact.id cannot be empty.`);
        if (!contact.name)
            throw new UserError(`contact.name cannot be empty.`);
        if (!this._contacts.find(c => c.id === contact.id))
            throw new UserError(`${contact} is not ${this.username}'s contact`);
        const beingFavoriteContact = this.ContactOfId(contact.id);
        if (beingFavoriteContact.isFavorite) {
            this._logger.debug(`${contact.name} is favorite already.`);
            return TypeScriptUtils_1.NewTuple2(Contact_1.Contact.Nobody, Contact_1.Contact.Nobody);
        }
        const existIdx = this._contacts.indexOf(beingFavoriteContact);
        this._contacts.splice(existIdx, 1);
        const favoriteContact = new Contact_1.Contact(beingFavoriteContact, true);
        this._contacts.push(favoriteContact);
        const changeRecordValue = [Contact_1.Contact.ISFAVORITE_PROPERTY_NAME, favoriteContact];
        this.addChangeRecord(new Entity_1.ChangeRecord(User.CONTACTS_PROPERTY_NAME, Entity_1.ChangeOperation.Update, changeRecordValue));
        await this.SaveAsync(this);
        return TypeScriptUtils_1.NewTuple2(favoriteContact, beingFavoriteContact);
    }
    async OnAddContactToFavoriteCommand(rtcCmd) {
        if (this._isService)
            throw new UserError("Not Implemented.");
        else {
            switch (rtcCmd.type) {
                case RtcCommand_1.CmdType.ResponseFail:
                    {
                        // 移除Contact失敗，Rollback本地資料
                        const beingFavoriteContact = new Contact_1.Contact(rtcCmd.contentTo());
                        await this.RollbackContactToPrevFavoriteAsync(beingFavoriteContact);
                    }
                    break;
            }
        }
    }
    async OnAddContactToFavoriteEvent(e) {
        if (this._isService)
            throw new UserError("Not Implemented.");
        else {
            const body = e.bodyTo();
            const favoriteContact = new Contact_1.Contact(body.Item1);
            let favoriteContactUserDto = UserDto_1.newUserDto(body.Item2);
            await this.InternalAddContactToFavoriteAsync(favoriteContact);
            if (!favoriteContactUserDto.isValid()) {
                const favoriteContactUser = await this._userRepo.userOfIdAsync(favoriteContact.id);
                favoriteContactUserDto = favoriteContactUser.toUserDto();
            }
            const evt = UserEvent_1.UserEvent.ContactBecameFavoriteEvent(this.toUserDto(), favoriteContact, favoriteContactUserDto);
            await this.publishEventAsync(evt, [IEventHub_1.EventReceiver.CLIENT]);
        }
    }
    async RemoveContactFromFavoriteAsync(contact) {
        const result = await this.InternalRemoveContactFromFavoriteAsync(contact);
        const notFavoriteContact = result.Item1;
        const beforeBeingNotFavoriteContact = result.Item2;
        if (notFavoriteContact === Contact_1.Contact.Nobody)
            return;
        if (this._isService)
            throw new UserError("Not Implemented.");
        else {
            await this.sendCommandAsync(UserCommand_1.UserCommand.RemoveContactFromFavoriteCommand(this.id, beforeBeingNotFavoriteContact));
        }
    }
    async InternalRemoveContactFromFavoriteAsync(contact) {
        if (!contact.id)
            throw new UserError(`contact.id cannot be empty.`);
        if (!contact.name)
            throw new UserError(`contact.name cannot be empty.`);
        if (!this._contacts.find(c => c.id === contact.id))
            throw new UserError(`${contact} is not ${this.username}'s contact`);
        const beingNotFavoriteContact = this.ContactOfId(contact.id);
        if (!beingNotFavoriteContact.isFavorite) {
            this._logger.debug(`${beingNotFavoriteContact.name} is not favorite already.`);
            return TypeScriptUtils_1.NewTuple2(Contact_1.Contact.Nobody, Contact_1.Contact.Nobody);
        }
        const existIdx = this._contacts.indexOf(beingNotFavoriteContact);
        this._contacts.splice(existIdx, 1);
        const notFavoriteContact = new Contact_1.Contact(beingNotFavoriteContact, false);
        this._contacts.push(notFavoriteContact);
        const changeRecordValue = [Contact_1.Contact.ISFAVORITE_PROPERTY_NAME, notFavoriteContact];
        this.addChangeRecord(new Entity_1.ChangeRecord(User.CONTACTS_PROPERTY_NAME, Entity_1.ChangeOperation.Update, changeRecordValue));
        await this.SaveAsync(this);
        return TypeScriptUtils_1.NewTuple2(notFavoriteContact, beingNotFavoriteContact);
    }
    async OnRemoveContactToFavoriteCommand(rtcCmd) {
        if (this._isService)
            throw new UserError("Not Implemented.");
        else {
            switch (rtcCmd.type) {
                case RtcCommand_1.CmdType.ResponseFail:
                    {
                        // 移除Contact失敗，Rollback本地資料
                        const beingNotFavoriteContact = new Contact_1.Contact(rtcCmd.contentTo());
                        await this.RollbackContactToPrevFavoriteAsync(beingNotFavoriteContact);
                    }
                    break;
            }
        }
    }
    async OnRemoveContactFromFavoriteEvent(e) {
        if (this._isService)
            throw new UserError("Not Implemented.");
        else {
            const body = e.bodyTo();
            const notFavoriteContact = new Contact_1.Contact(body.Item1);
            let notFavoriteContactUserDto = UserDto_1.newUserDto(body.Item2);
            await this.InternalRemoveContactFromFavoriteAsync(notFavoriteContact);
            if (!notFavoriteContactUserDto.isValid()) {
                const notFavoriteContactUser = await this._userRepo.userOfIdAsync(notFavoriteContact.id);
                notFavoriteContactUserDto = notFavoriteContactUser.toUserDto();
            }
            const evt = UserEvent_1.UserEvent.ContactBecameNotFavoriteEvent(this.toUserDto(), notFavoriteContact, notFavoriteContactUserDto);
            await this.publishEventAsync(evt, [IEventHub_1.EventReceiver.CLIENT]);
        }
    }
    async RollbackContactToPrevFavoriteAsync(contact) {
        this._logger.debug(`${this.username}修改${contact.name}的Favorite狀態失敗, 回復成${contact.isFavorite}`);
        const rollbackingContact = this.ContactOfId(contact.id);
        if (rollbackingContact === Contact_1.Contact.Nobody)
            return;
        const existIdx = this._contacts.indexOf(rollbackingContact);
        this._contacts.splice(existIdx, 1);
        const rollbackContact = new Contact_1.Contact(rollbackingContact, contact.isFavorite);
        this._contacts.push(rollbackContact);
        this.addChangeRecord(new Entity_1.ChangeRecord(User.CONTACTS_PROPERTY_NAME, Entity_1.ChangeOperation.Update, rollbackContact));
        await this.SaveAsync(this);
    }
    HasContact(aUserId) {
        return UserUtils_1.UserUtils.HasContact(this._contacts, aUserId);
    }
    HasAddedContact(aUserId) {
        return UserUtils_1.UserUtils.HasAddedContact(this._contacts, aUserId);
    }
    ContactOfId(aUserId) {
        const c = UserUtils_1.UserUtils.ContactOfId(this._contacts, aUserId);
        return c != null ? c : Contact_1.Contact.Nobody;
    }
    toUserDto() {
        if (this === User.INVALID_USER)
            return UserDto_1.UserDto.INVALID_USER;
        const newUserDto = new UserDto_1.UserDto();
        newUserDto.id = this.id;
        newUserDto.username = this.username;
        newUserDto.displayname = this.displayName;
        newUserDto.isOnline = this.isOnline;
        newUserDto.avatar = this.avatar;
        newUserDto.contacts = this.contacts.slice();
        return newUserDto;
    }
    static Builder(ur, ch, ep, isService = false, u) {
        return new UserBuilder(isService, ur, ch, ep, u);
    }
}
User.logger = LogManager_1.logManager.GetLogger("User");
User.CurrentVersion = UserDefinition_1.UserVersion;
User.ISONLINE_PROPERTY_NAME = "isOnline";
User.CONTACTS_PROPERTY_NAME = "contacts";
User.INVALID_USER = new User({
    _isService: false,
    _userRepo: new NullUserRepository_1.NullUserRepository(),
    _commandHub: new NullCommandHub_1.NullCommandHub(),
    _eventHub: new NullEventHub_1.NullEventHub(),
    _id: "",
    _version: User.CurrentVersion,
    _username: "",
    _displayName: "",
    _isOnline: false,
    _avatar: "",
    _contacts: [],
});
exports.User = User;
class UserBuilder {
    constructor(isService, userRepo, ch, en, user) {
        this._isService = false;
        this._id = "";
        this._version = User.CurrentVersion;
        this._username = "";
        this._displayName = "";
        this._isOnline = false;
        this._avatar = "";
        this._contacts = [];
        this._isService = isService;
        this._userRepo = userRepo;
        this._cmdHub = ch;
        this._evtHub = en;
        if (user) {
            this._id = user.id;
            this._version = user.version;
            this._username = user.username;
            this._displayName = user.displayName;
            this._isOnline = user.isOnline;
            this._avatar = user.avatar;
            this._contacts = user.contacts.slice();
        }
    }
    id(id) {
        this._id = id;
        return this;
    }
    username(un) {
        this._username = un;
        return this;
    }
    displayName(displayName) {
        this._displayName = displayName;
        return this;
    }
    isOnline(isOnline) {
        this._isOnline = isOnline;
        return this;
    }
    avatar(url) {
        this._avatar = url;
        return this;
    }
    contacts(contacts) {
        this._contacts = contacts;
        return this;
    }
    build() {
        return new User({
            _isService: this._isService,
            _commandHub: this._cmdHub,
            _eventHub: this._evtHub,
            _userRepo: this._userRepo,
            _id: this._id,
            _version: this._version,
            _username: this._username,
            _displayName: this._displayName,
            _isOnline: this._isOnline,
            _avatar: this._avatar,
            _contacts: this._contacts
        });
    }
}
exports.UserBuilder = UserBuilder;
exports.UserErrorName = "UserError";
class UserError extends CommonBaseError_1.CommonBaseError {
}
exports.UserError = UserError;
//# sourceMappingURL=User.js.map